import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { IStockComm, IStockFileEntry, IStockFolder, IStockLog, IUserLocale, IxellAPIService, Roles, StockLogAction } from 'src/app/tools/api.service'
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GroupedLocale } from '../cloud/cloud.component';
import moment, { Moment } from 'moment';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from '../../tools/header.service';

@Component({
    selector: 'cloud-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss']
})
export class CloudHistoryComponent implements OnInit, OnDestroy {
    StockLogAction = StockLogAction;
    role: Roles;
    Utils = Utils;

    @Input() possibleLocales: { [key: number]: GroupedLocale };
    @Input() rootFolders: IStockFolder[];
    @Input() myLocale: IUserLocale;

    readonly datenow: Date = new Date();

    // Objet
    logsToDisplay: IStockLog[] = [];
    possibleCountries: { [key: number]: string } = {};
    possibleCountriesForLanguages: { [key: number]: { [key: number]: string } } = {};
    possibleLanguages: { [key: number]: string } = {};
    possibleLanguagesForCountries: { [key: number]: { [key: number]: string } } = {};
    folderPaths: { [key: number]: string } = {};
    filenames: { [key: number]: string } = {};
    commnames: { [key: number]: string } = {};
    modes: { [key: number]: number } = {};

    hasChanged = false;
    isLoading = false;

    // Form controls
    readonly selectedCountry = new FormControl<number>(0, [Validators.required]);
    readonly selectedLanguage = new FormControl<number>(0, [Validators.required]);
    readonly startDate = new FormControl<Moment>((() => {
        const date = new Date();
        date.setDate(date.getDate() - 7);
        return moment(date);
    })(), [Validators.required]);
    readonly endDate = new FormControl<Moment>(moment(new Date()), [Validators.required, (control: AbstractControl): ValidationErrors | null => {
        if (this.startDate.value > control.value)
            return { mustBeSuperior: true };

        return null;
    }]);


    getDisplayColumns(mode: number) {
        /*
        const isFrance = (this.selectedCountry.value === 75 && this.selectedLanguage.value === 1);
        const tbl = ['name', 'lastEdit', 'unlisted', 'read', (isFrance || mode > 1) ? 'edit' : 'translate']
        if ((isFrance && mode < 2) || (this.adminKind == 0) || (mode === 4 && this.adminKind <= 2))
            tbl.push('delete');

        return tbl;
        */
    }

    // Sub
    private getCloudLogsSub: any;
    private roleSub: any;

    constructor(private readonly headerService: HeaderService, private readonly apiService: IxellAPIService, private translateService: TranslateService) { }

    ngOnInit() {

        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);

        for (let keyC in this.possibleLocales) {
            if (!(keyC in this.possibleCountries))
                this.possibleCountries[keyC] = this.possibleLocales[keyC].pays;

            if (!this.possibleLanguagesForCountries[keyC])
                this.possibleLanguagesForCountries[keyC] = {}

            for (let l of this.possibleLocales[keyC].langues) {
                if (!(l.idLangue in this.possibleLanguages))
                    this.possibleLanguages[l.idLangue] = l.langue;

                if (!this.possibleCountriesForLanguages[l.idLangue])
                    this.possibleCountriesForLanguages[l.idLangue] = {}

                this.possibleCountriesForLanguages[l.idLangue][keyC] = this.possibleLocales[keyC].pays;
                this.possibleLanguagesForCountries[keyC][l.idLangue] = l.langue;
            }
        }

        if (!Utils.isAdminLacour(this.role) && !Utils.isAdminRenault(this.role)) {
            this.selectedCountry.setValue(this.myLocale.idPays);
        } else {
            this.selectedCountry.setValue((this.myLocale.idPays === 75) ? 0 : this.myLocale.idPays); // Si France, on part de "tous"
        }

        const procFolders = (folders: IStockFolder[]) => {
            for (const folder of folders) {
                this.modes[folder.idStockFolder] = folder.mode;
                this.folderPaths[folder.idStockFolder] = folder.path;
                if (folder.children) {
                    procFolders(folder.children.filter(c => 'path' in c) as IStockFolder[]);
                    for (const file of folder.children.filter(c => 'contents' in c) as IStockFileEntry[]) {
                        for (const content of file.contents) {
                            this.filenames[content.idStockFileContent] = content.name;
                        }
                    }
                    for (const comm of folder.children.filter(c => 'idStockComm' in c) as IStockComm[]) {
                        this.commnames[comm.idStockComm] = comm.title;
                    }
                }
            }
        }

        procFolders(this.rootFolders);

        //console.log(this.filenames);

        this.search();
    }

    ngOnDestroy() {
        if (this.getCloudLogsSub != null) this.getCloudLogsSub.unsubscribe();
    }


    search() {
        this.hasChanged = false;
        this.isLoading = true;

        const startDate = new Date(Date.UTC(this.startDate.value.toDate().getFullYear(), this.startDate.value.toDate().getMonth(), this.startDate.value.toDate().getDate(), 0, 0, 0));
        const endDate = new Date(Date.UTC(this.endDate.value.toDate().getFullYear(), this.endDate.value.toDate().getMonth(), this.endDate.value.toDate().getDate(), 23, 59, 59));

        var country = 0;
        if (!Utils.isAdminLacour(this.role) && !Utils.isAdminRenault(this.role)) {
            country = this.selectedCountry.value;
        } else {
            country = (this.selectedCountry.value === 0) ? null : this.selectedCountry.value;
        }

        this.getCloudLogsSub = this.apiService.getCloudLogs(startDate, endDate, country, (this.selectedLanguage.value === 0) ? null : this.selectedLanguage.value).subscribe(data => {
            this.logsToDisplay = data;

            this.isLoading = false;
            if (this.getCloudLogsSub != null) this.getCloudLogsSub.unsubscribe();
        }, error => {
            this.isLoading = false;
            if (this.getCloudLogsSub != null) this.getCloudLogsSub.unsubscribe();
        })
    }

    translateFolderPath(path: string, translateDict: { [key: string]: string }) {
        return path.split('\\').map(elem => translateDict[elem]).join('\\');
    }

    getOrigin(details: string): string {
        const elements = details.split('|')[0].split(';');
        if (elements.length < 6)
            return '';

        if (elements[4] != '0')
            return this.possibleCountries[Number(elements[4])];

        if (elements[5] != '0')
            return this.possibleLanguages[Number(elements[5])];

        return '';
    }

    getDetails(child: IStockLog): string[] {
        if (child.action != StockLogAction.EDIT)
            return [];

        if (this.modes[child.idStockFolder] === 4)
            return this.getDetailsForComm(child);
        else
            return this.getDetailsForFile(child);
    }

    getDetailsForFile(child: IStockLog): string[] {
        const subs = child.details.split('|');
        const elements = subs[0].split(';');

        const hasEditedListing = (subs[1][0] === '1');
        const hasEditedContent = (subs[1][1] === '1');
        const hasEditedName = (subs[1][2] === '1');

        let result = [];

        if (hasEditedListing)
            result.push(this.translateService.instant((elements[3] === '1') ? 'cloud.history.details.markedAsUnlisted' : 'cloud.history.details.unmarkedAsUnlisted'));

        if (hasEditedContent && hasEditedName && !child.filename) {
            result.push(this.translateService.instant('cloud.history.details.deletedTranslation'));
        }
        else {
            if (hasEditedContent)
                result.push(this.translateService.instant('cloud.history.details.changedContent'));
            if (hasEditedName)
                result.push(this.translateService.instant('cloud.history.details.changedTitle', { title: child.filename.substring(child.filename.split('/')[0].length + 1) }));
        }

        return result;
    }

    getDetailsForComm(child: IStockLog): string[] {
        const subs = child.details.split('|');
        const elements = subs[0].split(';');

        const hasEditedDoc = (subs[1][0] === '1');
        const hasEditedBanner = (subs[1][1] === '1');
        const hasEditedTitle = (subs[1][2] === '1');
        const hasEditedStartDate = (subs[1][3] === '1');
        const hasEditedEndDate = (subs[1][4] === '1');
        const hasEditedCountry = (subs[1][5] === '1');
        const hasEditedTarrif = (subs[1][6] === '1');
        const hasEditedTech = (subs[1][7] === '1');

        let result = [];

        if (hasEditedDoc)
            result.push(this.translateService.instant('cloud.history.details.changedFile'));
        if (hasEditedBanner)
            result.push(this.translateService.instant('cloud.history.details.changedBanner'));
        if (hasEditedTitle)
            result.push(this.translateService.instant('cloud.history.details.changedTitle', { title: child.filename }));
        if (hasEditedStartDate)
            result.push(this.translateService.instant('cloud.history.details.changedStartDate'));
        if (hasEditedEndDate)
            result.push(this.translateService.instant('cloud.history.details.changedEndDate'));
        if (hasEditedCountry)
            result.push(this.translateService.instant('cloud.history.details.changedCountry'));
        if (hasEditedTarrif)
            result.push(this.translateService.instant('cloud.history.details.changedTariff'));
        if (hasEditedTech)
            result.push(this.translateService.instant('cloud.history.details.changedTech'));

        return result;
    }
}
